import { CheckCircle, LayoutDashboard, Plus } from "lucide-react";

export default function FinishSetupStep({
  business,
  onDashboard,
  onAddAnother,
}) {
  return (
    <div className="space-y-6 text-center">
      <div className="mx-auto h-16 w-16 rounded-2xl bg-green-100 text-green-600 flex items-center justify-center">
        <CheckCircle size={32} />
      </div>

      <div>
        <h2 className="text-2xl font-bold text-slate-900">
          Your business is set up
        </h2>

        <p className="text-slate-600 mt-2">
          {business?.name
            ? `${business.name} is ready inside RevUShield.`
            : "Your business is ready inside RevUShield."}
        </p>
      </div>

      <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5 text-left space-y-3">
        <SetupItem label="Business profile created" complete />
        <SetupItem label="Response preferences saved" complete />
        <SetupItem label="Google connection" complete={false} />
      </div>

      <div className="flex flex-col sm:flex-row gap-3">
        <button
          type="button"
          onClick={onAddAnother}
          className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-medium text-slate-700 hover:bg-slate-50 transition inline-flex items-center justify-center gap-2"
        >
          <Plus size={16} />
          Add Another Business
        </button>

        <button
          type="button"
          onClick={onDashboard}
          className="w-full rounded-xl bg-indigo-600 px-4 py-3 text-sm font-medium text-white hover:bg-indigo-700 transition inline-flex items-center justify-center gap-2"
        >
          Go to Dashboard
          <LayoutDashboard size={16} />
        </button>
      </div>
    </div>
  );
}

function SetupItem({ label, complete }) {
  return (
    <div className="flex items-center justify-between gap-4">
      <span className="text-sm font-medium text-slate-700">{label}</span>

      <span
        className={`text-xs font-medium px-3 py-1 rounded-full ${
          complete
            ? "bg-green-100 text-green-700"
            : "bg-slate-200 text-slate-600"
        }`}
      >
        {complete ? "Complete" : "Later"}
      </span>
    </div>
  );
}
